module.exports = __webpack_public_path__ + "/img/cloud-icon.3ebfc8a970.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/cloud-icon.png
// module id = 1389
// module chunks = 0